/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketsForStudentList } from '../../models/tickets-for-student-list';

export interface ApiStudentByExternalIdExternalIdTicketsGet$Params {
  external_id: string;

/**
 * #### String with a list of sort fields separated by `|`. Prepend a `+` or `-` symbol to indicate the sorting method. Example:  `+address|-name|-year`
 */
  sort?: string;

/**
 * #### Page number to retrieve. First page is 0
 */
  page?: number;

/**
 * #### Number of results to return. Default is no limit
 */
  limit?: number;

/**
 * #### List of filters to apply to the query. Each filter is a string in the format:'{"field":"field_name", "operator":"operator_name", "value":"str/number"}'
 */
  filter?: Array<string>;
}

export function apiStudentByExternalIdExternalIdTicketsGet(http: HttpClient, rootUrl: string, params: ApiStudentByExternalIdExternalIdTicketsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketsForStudentList>> {
  const rb = new RequestBuilder(rootUrl, apiStudentByExternalIdExternalIdTicketsGet.PATH, 'get');
  if (params) {
    rb.path('external_id', params.external_id, {});
    rb.query('sort', params.sort, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter', params.filter, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketsForStudentList>;
    })
  );
}

apiStudentByExternalIdExternalIdTicketsGet.PATH = '/api/student/by-external-id/{external_id}/tickets';
